import React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

import Typography from '@mui/material/Typography';

import { dateFormatter } from '@src/utils/dateHelpers';

const toLocaleStringSupportsLocales = (() => {
    try {
        new Date().toLocaleString('i');
    } catch (error) {
        return error instanceof RangeError;
    }

    return false;
})();

const FormattedDateField = (props) => {
    const {
        source,
    } = props;

    const record = useRecordContext();

    if (!record) return null;

    const value = dateFormatter(record[source]);
    const date = value instanceof Date ? value : new Date(record[source]);

    const options = {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    };

    const dateString = toLocaleStringSupportsLocales ? date.toLocaleString('en-us', options) : JSON.stringify(date);

    return (
        <Typography
            component="span"
            variant="body2"
        >
            {dateString}
        </Typography>
    );
};

FormattedDateField.propTypes = {
    source: PropTypes.string.isRequired,
};

export default FormattedDateField;
